<template>
  <div class="newsdetail">
    <!-- <div class="ggxq">
      <div>新闻公告<span> > {{newsInfo.title}}</span></div>
    </div> -->
    <div class="ggxq-con">
      <div>
        <div class="title ggxqtext"></div>
        <div class="newstitle">{{newsInfo.title}}</div>
        <div class="newstime">时间：{{newsInfo.formatTime}}</div>
        <!--        <p> {{$route.query.content}}</p>-->
        <p v-html="newsInfo.content"></p>
      </div>
    </div>
  </div>
</template>
<script>
  import {http} from '../fetch/api'
  import format from '../fetch/format'
  export default {
    data() {
      return {
        newsInfo:{}
      }
    },
    mounted() {
      this.getInfo()
    },
    methods:{

      async getInfo() {
        var data = await http.newsDetail(this.$route.query.newsId)
        this.newsInfo=data.data
        this.newsInfo.formatTime = format.formatDate(this.newsInfo.createTime)
      }
    }
  }
</script>
<style scoped>

  .ggxq {
    height: 60px;
    line-height: 60px;
    background: #f4f7f9;
  }

  .ggxq > div {
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
  }

  .ggxq span {
    color: #9b9a9a;
  }

  .ggxq-con > div {
    padding: 50px;
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .title {
    height: 67px;
    line-height: 67px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
    margin: 0 auto 35px auto;
    background-repeat: no-repeat;
    background-size: 750px;
    background-position: center;
  }

  .title span {
    padding-left: 50px;
    display: inline-block;
    background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: linear-gradient(73deg, #0c3b95, #cf5860);
    -webkit-background-clip: text;
    -ms-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent;
    font-weight: bold;
  }

  .ggxqtext {
    background-image: url("../assets/xwgg.png");
  }

  .newstitle {
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #3463b5;
    text-align: center;
    margin-bottom: 20px;
  }

  .newstime {
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #303030;
    text-align: center;
    margin-bottom: 30px;
  }

  p {
    font-size: 16px;
    margin-top: 20px;
    line-height: 28px;
    text-indent: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/components/newsdetail.vue